import React, { useEffect, useState } from "react";
import { Button, Clock, Notification, Toast } from "../../../../Components";
import apis from "../../../../Utils/apis";
import { get, post } from "../../../../Utils/axios";
import { subscribeCustomEvent } from "../../../../Utils/utils";

function Notifications() {
	const [Notifications, setNotifications] = useState([]);

	useEffect(() => {
		fetchNotifications();
		//Subscribing to new notifications
		const removeListener = subscribeCustomEvent("notification", pushNotification);
		return removeListener;
	}, []);

	const fetchNotifications = () => {
		get(apis.getNotifications, {}, (r, e) => {
			if (r) {
				setNotifications([...r.notifications].reverse());
			}
		});
	};

	const pushNotification = (notification) => {
		if (notification.type === "NEW_MESSAGE" && window.location.pathname === "/app/chat") {
			return;
		}
		setNotifications((prev) => [
			{
				notification,
				unread: true,
			},
			...prev,
		]);
	};

	const markRead = (index) => {
		setNotifications((prev) => prev.map((n, i) => (i === index ? { ...n, unread: false } : n)));
	};

	const clearNotifications = (params) => {
		post(apis.clearNotifications, {}, (r, e) => {
			if (r) {
				Toast.success("Cleared");
				fetchNotifications();
			}
		});
	};

	return (
		<>
			<div className="overflow-y-auto">
				<div className="sticky top-0 z-10 p-2 flex-center-between bg-canvas">
					<div className="text-sm font-semibold">Notifications</div>
					<Button onClick={clearNotifications} className="btn-xs" variant="outlined">
						Clear
					</Button>
				</div>
				<div className="p-2 pt-0">
					{Notifications.length > 0 ? (
						Notifications.map((n, i) => {
							//Parse stored notifications
							let notification = n.notification;
							if (typeof notification === "string") {
								notification = JSON.parse(notification);
							}
							return <Notification key={i} onHover={() => markRead(i)} createdAt={n.createdAt} unread={n.unread} type={notification.type} notification={notification} />;
						})
					) : (
						<div className="py-6 text-center text-label">No Notifications</div>
					)}
				</div>
			</div>
			<div>
				{/* <div className="p-2 pt-0">
					<QuickChat />
				</div> */}
				<div className="p-2 text-center text-[11px] text-secondary">
					<Clock />
				</div>
			</div>
		</>
	);
}

export default Notifications;
